<div class="  bg-body-tertiary p-2">

  <div class="container text-center mt-5">
    <span style="color:var(--primary-color);" class="fs-2  fw-medium ">Cuándo ir a <span class="fw-bolder">Terapia Física </span> </span>
  </div>



  <div class="container px-4 py-5" id="featured-3">
    <div class="row g-4 py-5 row-cols-1 row-cols-lg-5">
      <div *ngFor="let motivo of motivos; let i= index" class="feature col text-center">
        <div class="feature-icon d-inline-flex align-items-center  justify-content-center  ">
          <img ngSrc="./assets/img/terapiaFisica/{{motivo.imagen}}" class="" alt="" height="90" width="90">
        </div>
        <p class="text-secondary fs-5">{{ motivo.name }}</p>
      </div>
    </div>
  </div>

  <div class="container py-5 ">
    <div class="container text-center">
      <p class="fw-bold fs-5 pt-2" style="color: var(--secondary-color)">Si presentas algún síntoma, agenda al:</p>
    </div>
      <div class="d-grid gap-2 d-sm-flex justify-content-sm-center">
        <button class="buttonAction d-flex align-items-center justify-content-center">
          <img ngSrc="assets/img/movilink/llamadaIcon.svg" alt="llamadaLogo" class=" flex-shrink-0" height="30" width="30">
          <span class="text-light px-2 fs-1">5 50 50 52</span>
        </button>
        <a href="https://api.whatsapp.com/send/?phone=%2B593993183975&text&type=phone_number&app_absent=0" target="_blank" class="buttonAction d-flex align-items-center justify-content-center">
          <img ngSrc="assets/img/movilink/whatsapLogo.svg" alt="whatsapLogo" class=" flex-shrink-0" height="30" width="30">
          <span class="text-light px-2 fs-1">099 318 3975</span>
        </a>
      </div>



</div>
